<script>
export default {
    name: "WaiveredBillDetailsPrint",

    data() {

        return {
            patient: {},
            waiverItems: [],
        };
    },

    computed: {

        total() {

            if(!this.waiverItems.length) return 0;

            return this.waiverItems.map(waiver => waiver.grandTotal ? parseFloat(waiver.grandTotal) : 0)
                .reduce((sum,amt) => sum+amt);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ 
            this.fetchPatient(), this.fetchWaiverItems(), 
        ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchWaiverItems() {
            let url = `AccountsReports/GetWeiveredBIllDetails`;
                url += `?BillNo=${this.$route.query.BillNo}`;

            return this.$http.get(url).then(response => {
                this.waiverItems = response.data;
            }).catch(() => {});
        },

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.PatientID}`;

            return this.$http.get(url).then(response => {
              this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center text-base my-2">
            <h5 class="font-bold uppercase">Patient Waivered Bills</h5>
        </div>
        <div class="w-full text-center text-base my-2">
            <h5 class="font-bold uppercase">Receipt No: {{ $route.query.BillNo }}</h5>
        </div>
        <div class="w-full flex flex-wrap text-sm my-1">
            <div class="w-1/3 p-1">
                <h5 class="font-medium">Name: {{ patient.names }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium">IP NO: {{ patient.ipfileno || `-` }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium">OP File No: {{ patient.opfileno || `-` }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium">Visit No: {{ patient.visitNo || `-` }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium">Date: {{ 
                        waiverItems.length ? $root.formatDate(waiverItems[0].dateApproved) : `-` }}</h5>
            </div>
        </div>
        <div class="w-full p-1 my-1">
            <h5 class="font-medium">Payment Mode: {{ patient.pMode }}</h5>
        </div>
        <div class="w-full">
            <table class="table">
                <tbody>
                    <tr class="text-sm">
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Price</th>
                        <th class="p-tiny">Total</th>
                        <th class="p-tiny">Approved By</th>
                    </tr>
                    <tr class="text-xs" 
                        v-for="(waiverItem,idx) in waiverItems" :key="idx">
                        <td class="p-tiny">{{ waiverItem.item }}</td>
                        <td class="p-tiny">{{ waiverItem.quantity }}</td>
                        <td class="p-tiny">{{ waiverItem.charge | numberFormat }}</td>
                        <td class="p-tiny">{{ waiverItem.grandTotal | numberFormat }}</td>
                        <td class="p-tiny">{{ waiverItem.approvedBy }}</td>
                    </tr>
                    <tr>
                        <td colspan="2"></td>
                        <td>Total: {{ total | numberFormat }}</td>
                        <td colspan="2"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
